import { apiFetch } from '@/plugins/api.js';
import { getRuntimeApiUrl } from '@/plugins/hostAwareConfig.js';
export default {
  async editPassword(context, payload) {
    let url =
      `${getRuntimeApiUrl()}/user/edit-password`;

    const response = await apiFetch(url, {
      method: 'POST',
      body: JSON.stringify({
        email: payload.email,
        password: payload.password,
        new_password: payload.new_password,
        confirmed_password: payload.confirmed_password,
      })
    });

    const responseData = await response.json();

    if (responseData.status_code != '200') {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }

    // console.log('editPassword', responseData);
  },

  async getCardsSaved(context) {
    let url =
      `${getRuntimeApiUrl()}/user/cards`;

    const response = await apiFetch(url, {
      method: 'GET',
    });

    const responseData = await response.json();

    if (responseData.status_code != '200') {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }

    console.log('getCardsSaved', responseData);

    context.commit('setCards', responseData.cards);
  },

  async getSubscriptions(context) {
    let url =
      `${getRuntimeApiUrl()}/user/subscriptions`;

    const response = await apiFetch(url, {
      method: 'GET',
    });

    const responseData = await response.json();

    if (responseData.status_code != '200') {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }

    // console.log('getSubscriptions', responseData);

    context.commit('setSubscriptions', responseData.subscriptions.data);
  },

  async newCardSetupIntent(context) {
    let url =
      `${getRuntimeApiUrl()}/user/cards/intent`;

    const response = await apiFetch(url, {
      method: 'GET',
    });

    const responseData = await response.json();

    if (responseData.status_code != '200') {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }

    console.log('newCardSetupIntent', responseData);

    context.commit('setNewCardSetupIntent', responseData.intent);
  },

  async storePaymentMethod(context, payload) {
    let url =
      `${getRuntimeApiUrl()}/user/cards/create`;

    const response = await apiFetch(url, {
      method: 'POST',
      body: JSON.stringify({
        payment_method: payload.payment_method
      })
    });

    const responseData = await response.json();

    if (responseData.status_code != '200') {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }

    // console.log('storePaymentMethod', responseData);
    context.commit('setCards', responseData.cards);
  },

  async setDefaultCard(context, payload) {
    let url =
      `${getRuntimeApiUrl()}/user/cards/set-default`;

    const response = await apiFetch(url, {
      method: 'POST',
      body: JSON.stringify({
        payment_method: payload.id
      })
    });

    const responseData = await response.json();

    if (responseData.status_code != '200') {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }

    // console.log('setDefaultCard', responseData);
    context.commit('setCards', responseData.cards);
  },

  async deleteCard(context, payload) {
    let url =
      `${getRuntimeApiUrl()}/user/cards/delete`;

    const response = await apiFetch(url, {
      method: 'POST',
      body: JSON.stringify({
        payment_method: payload.id
      })
    });

    const responseData = await response.json();

    if (responseData.status_code != '200') {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }

    // console.log('setDefaultCard', responseData.cards);
    context.commit('setCards', responseData.cards);
  },
  async sendEmailVerification() {
    let url =
      `${getRuntimeApiUrl()}/user/sendEmailVerification`;

    const response = await apiFetch(url, {
      method: 'POST',
    });
    // console.log('sendEmailVerification start' );

    const responseData = await response.json();

    if (responseData.status_code != '200') {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }

    // console.log('sendEmailVerification', responseData);
  },



};
